import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from 'components/ui/dialog';
import { Button } from 'components/ui/button';
import { Separator } from 'components/ui/separator';
import { ui } from '../ui';

interface Props {
  open: boolean;
  /** The songs the request will contain (the checked ones, or the one from the details dialog). */
  titles: string[];
  busy: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const STEPS = [1, 2, 3] as const;

export function HelpDialog({ open, titles, busy, onClose, onConfirm }: Props) {
  const { t } = useTranslation('publishing');
  const n = titles.length;
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-[520px] gap-0 p-6">
        <DialogTitle className={`mb-1 ${ui.subhead}`}>{t('help_title')}</DialogTitle>
        <DialogDescription className={`mb-3 ${ui.muted}`}>
          {t('help_description', { count: n })}
        </DialogDescription>
        <ul className="m-0 mb-4 max-h-40 list-disc overflow-y-auto rounded-[10px] border border-[#E9E9E9] py-2 pl-8 pr-4">
          {titles.map((title, i) => (
            <li key={i} className={`py-0.5 ${ui.body}`}>
              {title}
            </li>
          ))}
        </ul>
        <div className="mb-4">
          {STEPS.map((i) => (
            <div key={i}>
              <div className="flex items-start gap-3 py-3">
                <div className="mt-px flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full bg-gray-100 text-sm font-bold text-[#222222]">
                  {i}
                </div>
                <div>
                  <div className={`mb-1 ${ui.subhead}`}>{t(`help_step${i}_title`)}</div>
                  <div className={ui.muted}>{t(`help_step${i}_desc`)}</div>
                </div>
              </div>
              {i < STEPS.length && <Separator />}
            </div>
          ))}
        </div>
        <div className="flex flex-col gap-2">
          <Button disabled={busy} onClick={onConfirm} className={ui.btnPrimary}>
            {t('register_label', { count: n })}
          </Button>
          <Button variant="outline" className={ui.btnSecondary} onClick={onClose}>
            {t('detail_close')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
